import './Home.css';

function Home() {
  return (
    <div className="home">
      <h1>Katie Schmid Fine Art</h1>
      <p className="home-tagline">New content coming soon.</p>
    </div>
  );
}

export default Home;
